// extracted by mini-css-extract-plugin
export default {"marginLeftMedium":"kTzGp2Z6xIWZzOrol3l8","content":"RJiAZlepoPmjBIYZKi2g","icon":"QgRmVnwqmV2p6PO8Boa3","smallSvg":"_trHazxYq2tTj9KQMNlV","mediumSvg":"QoQafDEMhI3QG1TSZePj"};